import { Box, Divider } from '@eatclubapp/ec-component-library';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PrimaryButton } from '../../components/button/PrimaryButton';
import { formatCurrency } from '../../utils/helpers';
import CancelMembershipPage from './CancelMembershipPage';
import { primaryButtonStyles } from './CancelMembershipStyles';
import ContinueButton from './ContinueButton';
import useStyles from './ExtraWeekPageStyles';
import CheckSVG from '../../assets/check.svg';
import BlobSVG from '../../assets/blob_2.svg';

const ExtraWeekPage = ({ currentStep, totalSteps, onContinue, onAccept, pauseFees, isSaving }) => {
  const classes = useStyles();

  const commissionPercent = Math.max(
    0,
    pauseFees?.data?.dineInOnlinePercent,
    pauseFees?.data?.takeAwayOnlinePercent,
  );

  const savingsData = {
    membershipFee: pauseFees?.data?.membershipFee,
    membershipFeeSaving: pauseFees?.data?.membershipFee,
    commissionPercent,
    commissionSaving: Math.round(
      (((pauseFees?.data?.avgDineinFees || 0) + (pauseFees?.data?.avgTakeAwayFees || 0)) *
        commissionPercent) /
        100,
    ),
  };

  return (
    <CancelMembershipPage
      currentStep={currentStep}
      totalSteps={totalSteps}
      isSaving={false}
      footerLeft={
        <PrimaryButton style={primaryButtonStyles} onClick={onAccept} loading={isSaving}>
          Yes, I accept this offer
        </PrimaryButton>
      }
      footerRight={
        <ContinueButton onClick={onContinue} loading={isSaving}>
          Continue to cancel
        </ContinueButton>
      }
    >
      <Box className={classes.mainContent}>
        <Box className={classes.title}>
          Would you consider staying on for 1 more week for{' '}
          <Box style={{ position: 'relative', display: 'inline-block', marginLeft: '12px' }}>
            <span style={{ position: 'relative', zIndex: 10 }}>free?</span>
            <BlobSVG
              style={{
                position: 'absolute',
                left: '-16px',
                top: '4px',
                zIndex: 1,
                color: '#DBDDFC',
              }}
            />
          </Box>
        </Box>

        <Box className={classes.summary}>
          That’s{' '}
          {formatCurrency(savingsData.commissionSaving + savingsData.membershipFeeSaving, false)} in
          value in your pocket and all you have to do is take a phone call from your Account
          Manager.
        </Box>
        <Box className={classes.pageContent}>
          <Box className={classes.feeTable}>
            <Box className={classes.feeTableRow}>
              <Box className={classes.feeRowLeft}>
                <Box className={classes.checkMark}>
                  <CheckSVG />
                </Box>
                <Box className={classes.feeRowMain}>
                  <Box className={classes.feeRowTitle}>No membership fee</Box>
                  <Box className={classes.feeRowSavings}>
                    Saving {formatCurrency(savingsData.membershipFeeSaving, false)}
                  </Box>
                </Box>
              </Box>
              <Box className={classes.feeRowRight}>
                <Box className={classes.feeRowDiscountContainer}>
                  <Box className={classes.feeRowDiscount}>
                    {formatCurrency(savingsData.membershipFee)}
                  </Box>
                </Box>
                <Box className={classes.feeRowNewPrice}>Free</Box>
              </Box>
            </Box>
            <Divider color='black' />
            <Box className={classes.feeTableRow}>
              <Box className={classes.feeRowLeft}>
                <Box className={classes.checkMark}>
                  <CheckSVG />
                </Box>
                <Box className={classes.feeRowMain}>
                  <Box className={classes.feeRowTitle}>No commission</Box>
                  <Box className={classes.feeRowSavings}>
                    Estimated savings: {formatCurrency(savingsData.commissionSaving, false)}
                  </Box>
                </Box>
              </Box>
              <Box className={classes.feeRowRight}>
                <Box className={classes.feeRowDiscountContainer}>
                  <Box className={classes.feeRowDiscount}>{savingsData.commissionPercent}%</Box>
                </Box>
                <Box className={classes.feeRowNewPrice}>Free</Box>
              </Box>
            </Box>
            <Divider color='black' />
          </Box>
        </Box>
      </Box>
    </CancelMembershipPage>
  );
};

const mapStateToProps = (state) => ({
  pauseFees: state.pauseFees,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ExtraWeekPage);
